module.exports = __webpack_public_path__ + "media/images/responsive/fairs/cv/header_visit-d932c73e21f3eaac6a843d8d341d720e.png";